import { FunctionComponent } from 'react'
import { LayoutHeaderProps } from './types'
import useStyles from './styles'
import { Text } from '@conexasaude/conexa-hero'
import { RenderIf } from '@/components/RenderIf'

export const LayoutHeader: FunctionComponent<LayoutHeaderProps> = ({
  title,
  caption,
  size = 'paragraphLarge',
  titleColor,
}) => {
  const styles = useStyles({ size })

  return (
    <div css={styles.container}>
      <RenderIf condition={typeof title === 'string'}>
        <Text variant={size} color={titleColor}>
          {title}
        </Text>
      </RenderIf>

      <RenderIf condition={typeof caption === 'string'}>
        <Text variant="paragraphLarge" css={styles.caption}>
          {caption}
        </Text>
      </RenderIf>
    </div>
  )
}
